const ORDER_STATUS = {
  DRAFT: "DRAFT",
  SUCCESS: "SUCCESS",
};

export { ORDER_STATUS };
